import axios from 'axios';

const useSavePipeSpecs = () => {
  return async ({ estimateId, specs }) => {
    if (!estimateId) throw new Error('Estimate ID is required.');

    const payload = specs.map((item) => ({
      estimateId,
      lineClass: item.lineClass,
      baseQty: item.baseQty,
      classLocation: item.classLocation,
      grade: item.grade,
      wallThickness: item.wallThickness,
      wtOverride: item.wtOverride,
      size: item.size,
      tensileStrength: item.tensileStrength,
      orderQty: item.orderQty,
      percentOverBuy: item.percentOverBuy,
      internalCoating: item.internalCoating === 'Yes',
      coatingPerFt: item.coatingCostPerFt,
      coatingPrice: item.coatingPrice,
      lbsPerFt: item.lbsPerFt,
      tons: item.tons,
      maop: item.maop,
    }));

    await axios.put(`/api/PipelinePricing/update-pipe-specs/${estimateId}`, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
  };
};

export default useSavePipeSpecs;
